import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Remet en haut de page à chaque navigation, et scrolle sur la bonne section
// quand l'URL contient un hash (ex. /#manifeste depuis une autre page).
const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      return undefined;
    }
    let tries = 0;
    let lastHeight = -1;
    let correction;
    const timer = setInterval(() => {
      const el = document.querySelector(hash);
      const height = document.body.scrollHeight;
      // on attend que l'élément existe ET que la hauteur de page soit stable
      if (el && height === lastHeight) {
        clearInterval(timer);
        const go = () => {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
          else el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        go();
        correction = setTimeout(go, 900);
      } else if (++tries > 40) {
        clearInterval(timer);
      }
      lastHeight = height;
    }, 120);
    return () => { clearInterval(timer); clearTimeout(correction); };
  }, [pathname, hash]);

  return null;
};

export default ScrollManager;
